import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import messageInfoFragment from '../../fragments/message/messageInfo';

export const editMessageMutation = gql`
  mutation editMessage($input: EditMessageInput!) {
    editMessage(input: $input) {
      ...messageInfo
    }
  }
  ${messageInfoFragment}
`;

const editMessageOptions = {
  props: ({ mutate }) => ({
    editMessage: input =>
      mutate({
        variables: {
          input,
        },
      }),
  }),
};

export default graphql(editMessageMutation, editMessageOptions);
